$(function() {
    $('.filter-selector').on('change', function () {
        var newUrl = $(this).val();

        window.location = newUrl;
    });
});
